import api from './api';
import {
  InformePersonalizadoDetalle,
  InformePersonalizadoListItem,
  InformePersonalizadoUpsert,
  ModuloInformePersonalizado,
  UsuarioEmpresaOpcion,
  normalizarDetalle,
  normalizarListItem,
  statusHttp,
} from '../utils/informePersonalizadoDefinicion';

const BASE = '/api/informes-personalizados';

export class InformePersonalizadoAusenteError extends Error {
  constructor() {
    super('El informe no está en tu listado.');
    this.name = 'InformePersonalizadoAusenteError';
  }
}

function filas(data: unknown): Record<string, unknown>[] {
  if (Array.isArray(data)) return data as Record<string, unknown>[];
  if (data && typeof data === 'object' && Array.isArray((data as { items?: unknown }).items)) {
    return (data as { items: Record<string, unknown>[] }).items;
  }
  return [];
}

const informesPersonalizadosService = {
  list: async (modulo: ModuloInformePersonalizado): Promise<InformePersonalizadoListItem[]> => {
    const response = await api.get(BASE, { params: { modulo } });
    return filas(response.data)
      .map((row) => normalizarListItem(row, modulo))
      .filter((item) => item.modulo === modulo && Number.isFinite(item.id));
  },

  get: async (id: number, modulo: ModuloInformePersonalizado): Promise<InformePersonalizadoDetalle> => {
    try {
      const response = await api.get(`${BASE}/${id}`);
      return normalizarDetalle(response.data as Record<string, unknown>, modulo);
    } catch (error) {
      if (statusHttp(error) === 404) throw new InformePersonalizadoAusenteError();
      throw error;
    }
  },

  create: async (
    payload: InformePersonalizadoUpsert,
  ): Promise<InformePersonalizadoDetalle> => {
    const response = await api.post(BASE, payload);
    return normalizarDetalle(response.data as Record<string, unknown>, payload.modulo);
  },

  update: async (
    id: number,
    payload: InformePersonalizadoUpsert,
  ): Promise<InformePersonalizadoDetalle> => {
    const response = await api.put(`${BASE}/${id}`, payload);
    return normalizarDetalle(response.data as Record<string, unknown>, payload.modulo);
  },

  remove: async (id: number): Promise<void> => {
    await api.delete(`${BASE}/${id}`);
  },

  listUsuariosEmpresa: async (): Promise<UsuarioEmpresaOpcion[]> => {
    const response = await api.get(`${BASE}/usuarios`);
    return filas(response.data)
      .map((row) => ({
        id: Number(row.id ?? row.Id),
        nombre: String(row.nombre ?? row.Nombre ?? '').trim(),
        usuario: String(row.usuario ?? row.Usuario ?? '').trim(),
      }))
      .filter((usuario) => Number.isInteger(usuario.id) && usuario.id > 0 && usuario.usuario.length > 0)
      .map((usuario) => ({
        ...usuario,
        nombre: usuario.nombre || usuario.usuario,
      }))
      .sort((left, right) => left.nombre.localeCompare(right.nombre, 'es'));
  },
};

export default informesPersonalizadosService;
